// extracted by mini-css-extract-plugin
export default {"content":"tee-image-popup__content___PoLbK","slider":"tee-image-popup__slider___XRsp1","imageWrapper":"tee-image-popup__imageWrapper___V1XsJ"};